// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"384": "0c232ab98873cec0","436": "f8cae568b557bff5",}[chunkId] + ".js"
}